export default __webpack_public_path__ + "static/tertiary-3-6d9d10b8ae465f40477f4a8f6dd5f23a.jpg";